import { useEffect, useState } from "react";
import { IUsersData } from "../slices/usersSlice";

const useFilterUsers = (users: IUsersData[], type: number) => {
  const [usersfiltered, setusersfiltered] = useState<IUsersData[]>([]);
  const [filter, setfilter] = useState<number>(type);

  useEffect(() => {
    let newFilteredUsers;
    if (filter >= 1) {
      newFilteredUsers =
        users.length > 0 && filter && filter !== 0
          ? users.filter((user: IUsersData) => user?.idarea === filter)
          : users;
    } else {
      switch (filter) {
        case -1:
          newFilteredUsers = users;
          break;
        case -2:
          console.log("------ caso -2 inactivos------------", users.length > 0);
          newFilteredUsers =
            users.length > 0 && filter
              ? users.filter((user: IUsersData) => Number(user?.state) === 0)
              : users;
          break;
        default:
          console.log("--------------ENTRO DEFUALT----------------------");
          newFilteredUsers = users;
          break;
      }
    }

    // Evitar actualizar el estado si el valor es el mismo
    if (JSON.stringify(newFilteredUsers) !== JSON.stringify(usersfiltered)) {
      setusersfiltered(newFilteredUsers);
    }
  }, [filter, users, type, usersfiltered]);


  return {
    usersfiltered,
    setfilter,
    filter
  };
}

export { useFilterUsers };